import { defineLocale } from "../../registry";

const filters = defineLocale({
  ru: {
    "filters.label": "Фильтры каталога",
    "filters.status": "Статус",
    "filters.category": "Категория",
    "filters.country": "Страна",
    "filters.city": "Город",
    "filters.partner": "Партнёр",
    "filters.q": "Поиск по названию",
    "filters.all": "Все",
    "filters.search": "Найти",
    "filters.reset": "Сбросить фильтры",
    "filters.categoriesUnavailable": "Список категорий недоступен",
    "filters.partnersUnavailable": "Список партнёров недоступен",
    "queue.label": "Очередь действий",
    "queue.all": "Все пики",
    "queue.price_stale": "Требуется обновить цену",
    "queue.expiring": "Скоро истекают",
    "queue.gate_failed": "Не пройдена проверка публикации",
    "queue.link_dead": "Ссылка не работает",
    "queue.link_unconfirmed": "Ссылка не подтверждена",
  },
  en: {
    "filters.label": "Catalog filters",
    "filters.status": "Status",
    "filters.category": "Category",
    "filters.country": "Country",
    "filters.city": "City",
    "filters.partner": "Partner",
    "filters.q": "Search by title",
    "filters.all": "All",
    "filters.search": "Search",
    "filters.reset": "Reset filters",
    "filters.categoriesUnavailable": "Category list is unavailable",
    "filters.partnersUnavailable": "Partner list is unavailable",
    "queue.label": "Action queue",
    "queue.all": "All picks",
    "queue.price_stale": "Price needs update",
    "queue.expiring": "Expiring",
    "queue.gate_failed": "Publish gate failed",
    "queue.link_dead": "Link is dead",
    "queue.link_unconfirmed": "Link is not confirmed",
  },
});

export default filters;
